import { createStore } from "vuex";
import createPersistedState from "vuex-persistedstate";
import cookieUtils from "../utils/Cookies";
export default createStore({
  plugins: [createPersistedState()],
  state: {
    loggedUser: {},
    cartItems: [],
    refreshToken: "",
    access_token: "",
    isLoggedIn: false,
    roles: [],
    userId: "",
  },
  getters: {
    loggedUser: () => cookieUtils.get("mattaAuth"),
    isLoggedIn: () => !!cookieUtils.get("token"),
    userApps: () => cookieUtils.get("mattaAuth")?.subAppCodes,
    // eslint-disable-next-line no-unused-vars
    userId: () => cookieUtils.get("mattaAuth")?.id,
    token: () => cookieUtils.get("token"),
    userType: () => cookieUtils.get("roles")?.[0],
    cartItems: (state) => state.cartItems,
    accessToken: () => cookieUtils.get("token"),
    refreshToken: () => cookieUtils.get("mattaAuth")?.refreshToken,
    cartTotal: (state) => state.cartItems.length,
    totalAmount: (state) => {
      return state.cartItems
        .map((item) => item.packagePrice * item.quantity)
        .reduce((a, b) => {
          return Number(a) + Number(b);
        }, 0);
    },
  },
  mutations: {
    setUser(state, data) {
      state.loggedUser = data;
      state.roles = data.roles;
      state.isLoggedIn = true;
      state.userId = data.id;
      state.refreshToken = data.refreshToken;
      state.access_token = data.jwToken;
    },
    setUserId(state, id) {
      state.userId = id;
    },
    setRefreshToken(state, refreshToken) {
      state.refreshToken = refreshToken;
    },
    setAccessToken(state, token) {
      state.access_token = token;
    },

    clearUserData(state) {
      state.loggedUser = {};
      state.refreshToken = "";
      state.access_token = "";
      state.isLoggedIn = false;
      state.userId = "";
    },
    clearCart(state) {
      state.cartItems = [];
    },
    addToCart(state, item) {
      state.cartItems = [...state.cartItems, item];
    },
    updateCart(state, item) {
      state.cartItems = [...item];
    },
    setCart(state, item) {
      state.cartItems = item;
    },
    removeFromCart(state, packageId) {
      state.cartItems = state.cartItems.filter(
        (item) => item.packageId !== packageId
      );
    },
  },
  actions: {
    // eslint-disable-next-line no-unused-vars
    async handleAddToCart({ state, commit }, item) {
      let check = state.cartItems.some((i) => i.packageId == item.packageId);
      if (check) {
        return { status: false, message: "Already in cart" };
      }
      commit("addToCart", item);
      return { status: true, message: "Added to cart" };
    },
    async handleCartUpdate({ state, commit }, item) {
      let updatedItem = state.cartItems.map((i) => {
        if (i.packageId == item.packageId) {
          i.quantity = item.quantity;
        }
        return i;
      });

      commit("updateCart", updatedItem);
    },
    async handleToken({ commit }, token) {
      commit("setAccessToken", token);
      return { status: true, message: "updated" };
    },
  },
  modules: {},
});
